import { useEffect, useRef, useState } from 'react';

export default function CTAFinal() {
  const sectionRef = useRef<HTMLElement>(null);
  const [scrollY, setScrollY] = useState(0);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setInView(true);
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative h-[90vh] md:h-screen flex items-center justify-center overflow-hidden"
      style={{ backgroundColor: '#0E1412' }}
    >
      {/* Ambient glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none z-0"
        style={{
          width: '800px',
          height: '800px',
          background: 'radial-gradient(circle, rgba(200, 169, 106, 0.04) 0%, transparent 60%)',
          filter: 'blur(60px)',
          transform: `translate(-50%, -50%) scale(${1 + scrollY * 0.0002})`,
        }}
      />

      {/* Background image - editable */}
      <div
        className="absolute inset-0 w-full h-full z-0"
        style={{
          backgroundImage: `url(https://storage.readdy-site.link/project_files/a5718860-87a7-40cd-af11-814f205df039/0ca934c3-0788-42ad-ac49-2038c4cb7bc6_compressed_ESCRIITORIO.webp)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transform: `scale(${1 + scrollY * 0.0003})`,
          opacity: 0.7,
        }}
      />

      {/* Dark gradient overlay for text readability */}
      <div
        className="absolute inset-0 z-[1] pointer-events-none"
        style={{
          background: 'linear-gradient(180deg, rgba(14, 20, 18, 0.75) 0%, rgba(14, 20, 18, 0.55) 50%, rgba(14, 20, 18, 0.75) 100%)',
        }}
      />

      <div
        className="relative z-10 text-center px-6 md:px-12 max-w-[700px] mx-auto"
        style={{
          opacity: inView ? 1 : 0,
          transform: inView ? 'translateY(0)' : 'translateY(30px)',
          transition: 'all 1s ease-out',
        }}
      >
        <div
          className="w-12 h-12 mx-auto mb-8 rounded-full flex items-center justify-center"
          style={{
            backgroundColor: 'rgba(200, 169, 106, 0.1)',
            border: '1px solid rgba(200, 169, 106, 0.2)',
          }}
        >
          <i className="ri-heart-3-line text-xl" style={{ color: '#C8A96A' }} />
        </div>

        <h2
          className="text-3xl md:text-5xl lg:text-6xl mb-10"
          style={{
            fontFamily: 'var(--font-heading)',
            color: '#F8F7F5',
            fontWeight: 400,
            lineHeight: 1.25,
          }}
        >
          Seu corpo envia sinais todos os dias.
          <br />
          Talvez seja o momento de
          <br />
          <span style={{ color: 'rgba(200, 169, 106, 0.8)' }}>
            começar a ouvi-los.
          </span>
        </h2>

        <a
          href="https://wa.me/5585999372109?utm_source=site&utm_medium=cta_final&utm_content=agendar_consulta"
          target="_blank"
          rel="noopener noreferrer"
          className="group relative inline-flex items-center justify-center px-10 py-4 rounded-full text-base font-semibold tracking-[0.04em] whitespace-nowrap overflow-hidden cursor-pointer transition-all duration-500"
          style={{
            backgroundColor: 'rgba(200, 169, 106, 0.9)',
            color: '#0E1412',
            fontFamily: 'var(--font-body)',
          }}
        >
          <span className="relative z-10">Agendar consulta</span>
          <div
            className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            style={{ backgroundColor: 'rgba(200, 169, 106, 1)' }}
          />
        </a>
      </div>
    </section>
  );
}